import { getData } from '../modules/fetch';

const getCustomers = (callback) => {
  getData('/customers/listings/1,999')
    .then((data) => {
      if (data)
        callback(data);
    })
    .catch((err) => {
      console.error(err);
    });
}

export default getCustomers;
